import { ADMIN } from 'src/constants/constants';

export const isAdmin = (userGroup: string): boolean =>
  userGroup === ADMIN ? true : false;
